import React, { useEffect, useState } from 'react';
import GenericCommonRadioField from '../../components/moduleCommonFormik/GenericCommonRadioField.component';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Field, useFormikContext } from 'formik';
import GenericFormCard from '../../components/moduleCommonFormik/GenericFormCard.component';
import { endpoints, POST, requestInfo } from '../../services/modulesServices/userManagement.api';
import { KYC_ESIGN_FLAG, TENANT_ID } from '../../utils/constants';
import Select from 'react-select';
import _ from 'lodash';

export const EsignModal = () => {
    const { t } = useTranslation();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    console.log(user);

    const formik = useFormikContext<any>();
    const { values, errors, touched, setFieldValue, setFieldTouched, setValues } = useFormikContext<any>();
    const [dropdownData, setDropdownData] = useState<any>([]);

    const options = KYC_ESIGN_FLAG
        ? [
              { value: 'DSC', title: 'Token Based Sign' },
              { value: 'EKYC', title: 'KYC Based Sign' }
          ]
        : [{ value: 'DSC', title: 'Token Based Sign' }];

    const handleOnChange = (e: any) => {
        setFieldValue('esignOption', e.target.value);
    };

    useEffect(() => {
        (async () => {
            const payload = { RequestInfo: requestInfo(), tenantId: TENANT_ID, uuid: user?.uuid ? [user?.uuid] : null };
            const { data } = await POST(endpoints.userV1Search, payload);
            const options = data.user?.[0].esignUsernames.map((val: any) => ({ value: val, label: val }));
            setDropdownData(options);
        })();
    }, []);

    const classes = {
        control: (state: any) => (state.isDisabled ? 'select-disabled form-control was-validated form-border-rad ps-0 mt-0' : `form-control was-validated form-border-rad ps-0 mt-0 `),
        placeholder: (state: any) => 'placeholder-style',
        indicatorSeparator: (state: any) => 'd-none',
        clearIndicator: (state: any) => 'select-clear-indicator pe-3',
        dropdownIndicator: (state: any) => 'd-block pe-3 select-dropdown-indicator',
        option: (state: any) => (state.isFocused ? 'option-on-focus' : state.isSelected ? 'bg-transparent option-style text-black' : 'option-style'),
        menu: (state: any) => 'menu-style my-0',
        menuList: (state: any) => 'py-0 rounded',
        singleValue: (state: any) => 'single-option-style ps-0',
        valueContainer: (state: any) => 'ps-0',
        multiValue: (state: any) => 'select-multi-value',
        multiValueLabel: (state: any) => 'select-multi-value-label',
        multiValueRemove: (state: any) => 'select-multi-value-remove'
    };

    return (
        <div>
            <Card>
                <Card.Body>
                    <div className='d-flex font-inter'>
                        <label htmlFor={'esignOption'} title={'Select signing option'} className='pb-2 file-form-label' style={{ width: 'fit-content' }}>
                            {t('SELECT_SIGNING_OPTION', 'Select signing option')}
                        </label>
                    </div>
                    <div role='group' aria-labelledby='my-radio-group' className='d-flex' style={{ width: '80%' }}>
                        {!!options?.length &&
                            options.map(
                                (val: any) =>
                                    !val?.isDisabled && (
                                        <label className={`pe-4 m-2 w-100 cursor-pointer font-inter `} key={val?.value}>
                                            <Field
                                                type='radio'
                                                name={'esignOption'}
                                                onChange={(e: any) => {
                                                    handleOnChange(e);
                                                }}
                                                key={val?.value}
                                                value={val?.value}
                                                disabled={false}
                                                className={'cursor-pointer'}
                                            />
                                            {val?.title}
                                        </label>
                                    )
                            )}
                    </div>
                    {KYC_ESIGN_FLAG && values?.esignOption === 'EKYC' && (
                        <div className={`py-3 col-sm-6`}>
                            <div className='d-flex'>
                                <label htmlFor={'esignUsername'} className='pb-2 file-form-label' style={{ maxWidth: '95%' }} title={'Username'}>
                                    {'Username'}
                                </label>
                            </div>
                            <Select
                                name={'esignUsername'}
                                id={'esignUsername'}
                                options={[{ value: null, label: 'Please Select' }, ...dropdownData]}
                                classNamePrefix='react-select'
                                classNames={classes}
                                unstyled={true}
                                placeholder='Please Select'
                                onChange={(e: any) => {
                                    setFieldValue('esignUsername', e.value);
                                }}
                                onBlur={() => {
                                    setFieldTouched('esignUsername', true);
                                }}
                                // value={values.esignUsername}
                            />
                        </div>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};
